import React from 'react';
import { Field, FieldProps } from 'react-final-form';
import { FormLabel, makeStyles } from '@material-ui/core';
import classNames from 'classnames';

import ToggleOptionsButtons from 'components/buttons/ToggleOptions';

const useStyles = makeStyles({
  disabled: {
    opacity: 0.5,
  },
});

const ToggleOptions = ({
  className,
  name,
  options,
  multi,
  onChange,
  disabled,
  ...rest
}: {
  className?: string;
  name: string;
  options: Array<{ value: any; label: string }>;
  multi?: boolean;
  onChange?: (option: boolean) => void;
  disabled?: boolean;
} & FieldProps<any, any>) => {
  const classes = useStyles();

  return (
    <Field
      {...rest}
      name={name}
      render={({ input: { value, onChange: fieldOnChange }, meta: { touched, error } }) => {
        const handleChange = (option) => {
          if (onChange) {
            onChange(option);
          } else {
            fieldOnChange(option);
          }
        };
        return (
          <div className={classNames(className, disabled && classes.disabled)}>
            <ToggleOptionsButtons
              value={value}
              options={options}
              multi={multi}
              error={touched && error}
              onChange={handleChange}
            />
            {touched && error && <FormLabel error>{error}</FormLabel>}
          </div>
        );
      }}
    />
  );
};

export default ToggleOptions;
